<template>
  <div class="application-sub-menu">
    <div class="sub-items" :class="{'active': 0 == activeNum}" @click="$router.transfer(RouteKey.OPEN_APP_DISPLAY)">公有云服务</div>
    <div class="sub-items" :class="{'active': 1 == activeNum}" @click="$router.transfer(RouteKey.OPEN_PRIVATE_DISPLAY)">私有云授权</div>
    <div class="sub-items" :class="{'active': 2 == activeNum}" @click="$router.transfer(RouteKey.OPEN_YOUTU_BOX_DISPLAY)">优图盒子授权</div>
    <div class="sub-items" :class="{'active': 3 == activeNum}" @click="$router.transfer(RouteKey.OPEN_SDK_DISPLAY)">离线SDK</div>
  </div>
</template>

<script>
import RouteKey from '@/common/RouteKey';
export default {
  props: ['activeNum'],
  data() {
    return {
      RouteKey
    };
  }
};
</script>

<style lang="less" scoped>
.application-sub-menu{
  height: 75px;
  width: 1170px;
  margin: 0 auto;
  border-bottom: 1px solid #dcdcdc;
  div{
    box-sizing: border-box;
  }
  .sub-items{
    cursor: pointer;
    margin-right: 64px;
    float: left;
    line-height: 72px;
    font-size: 20px;
    color: #666666;
    &.active{
      color: #00a4ff;
      border-bottom: 3px solid #00a4ff;
    }
    &:hover{
      color: #00a4ff;
      border-bottom: 3px solid #00a4ff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/application/panels/common/SubMenu.vue